import { Component, HostListener, OnInit, ViewChild, Input,  } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IonModal, NavController } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core/components';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { LoadingController, AlertController } from '@ionic/angular';
import { EventsService } from 'src/app/providers/events/events.service';
import { Subject, from } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Capacitor } from "@capacitor/core";
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})

export class HomePage implements OnInit {
  @ViewChild('username') usernameInput;
  @ViewChild(IonModal) modalLogin: IonModal;
  @ViewChild(IonModal) modalPassReset: IonModal;
  private unsubscribe$ = new Subject<void>(); 
  
  loginForm: FormGroup;
  resetForm: FormGroup;
  username: string;
  password: string;
  year:number;
  isLoggedIn:boolean;
  welcome_message:string;
  portalVersion:string;
  isLoginModalOpen = false;
  isResetModalOpen = false;
  savedCount: any;
  currentSavedSubmission: any;
  rememberme: boolean = false;

  constructor(
    public storageService: StorageService,
    private apiService: ApiService,
    public formBuilder: FormBuilder,
    private loadingCtrl: LoadingController,
    public events: EventsService,
    private alertController: AlertController,
    private navCtrl: NavController,
    private cookieService: CookieService,

    ) 
    { 
      
      this.loginForm = this.formBuilder.group({
        username: ['', [Validators.required]],
        password: ['', [Validators.required, Validators.minLength(6)]],
      });
      this.resetForm = this.formBuilder.group({
        email: ['', [Validators.required, Validators.email]],
      });
    }
    async ionViewDidEnter() { 
      document.title = "Medbill Client Portal - Home";
      this.storageService.get('portalVersion').then(res => {
        this.portalVersion = res;
      });
      this.loginForm.reset();
      this.year = new Date().getFullYear();   
      from(this.storageService.getObject('mbeUser'))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((userResult) => {
        this.updateLogin(userResult);
      });

    }
    ngOnInit() { 
    }

    async checkSavedSubmissions() {
      this.savedCount = 0;
      var params;  
      params = {
        isportal: 'true',
      };  
      await this.apiService
        .post('data/check-saved-submissions', params)
        .subscribe(
          (res) => {
            if (res.error === false) {
              this.savedCount = res.data.saved_count;
              this.currentSavedSubmission = res.data.submissionid;

            }
          },
          (err) => {
            //console.log(err);
          }
        );
    }

    async loginError(error:string|null) {
      var errmesssage = 'There was a problem with your login.';
      if (error)
      {
        errmesssage = error;
      }
      if (!this.loginForm.controls.username.valid)
      {
        errmesssage+= ' Username is required.';
      }
      if (!this.loginForm.controls.password.valid)
      {
        errmesssage+= ' Password must be at least 6 characters in length.'
      }
      const alert = await this.alertController.create({
        header: 'Login Error',
        message: errmesssage,
        buttons: ['OK'],
      });
      
      await alert.present();
    }
    async resetError(error:string|null) {
      var errmesssage = 'There was a problem requesting your password reset.';
      if (error)
      {
        errmesssage = error;
      }
      if (!this.resetForm.controls.email.valid)
      {
        errmesssage+= ' A valid email is required.';
      }
      
      const alert = await this.alertController.create({
        header: 'Password Reset Error',
        message: errmesssage,
        buttons: ['OK'],
      });
      
      await alert.present();
    }

    async resetSuccess(msg:string|null) {
      const alert = await this.alertController.create({
        header: 'Reset Success',
        message: msg,
        buttons: ['OK'],
      });
      
      await alert.present();
    }

    updateLogin(userResult: any) {
      if (userResult) {
        this.isLoggedIn = true;
        this.welcome_message = 'Welcome back ' + userResult.first_name + '.';
        this.checkSavedSubmissions(); 
      } else {
        this.isLoggedIn = false;
        var portalmessage = '';
        const params = {
          version: this.portalVersion
        };
        this.apiService.post('portalMessage', params).subscribe(
          async (res) => {
            if (res.error === false) {
              //console.log(res);
              if (res.data.message)
              {
                if (res.data.message_type == 'info')
                {
                  portalmessage = '<br><br><div class="portalinfomessageouter"><div class="portalinfomessageinner">'+res.data.message+'</div></div>';
                }
                else if (res.data.message_type == 'success')
                {
                  portalmessage = '<br><br><div class="portalsuccessmessageouter"><div class="portalsuccessmessageinner">'+res.data.message+'</div></div>';
                }
                else
                {
                  portalmessage = '<br><br><div class="portalmessageouter"><div class="portalmessageinner">'+res.data.message+'</div></div>';
                }
              }
              //console.log(portalmessage);
              this.welcome_message = '<div style="max-width:600px;margin:auto;"><span class="welcome_title">Welcome</span></div><br><span class="welcome_text">Welcome to the web portal for Medbill clients!<br><br>Please login with your <span class="regapp">registered app credentials</span>.<br><br>If you need assistance logging in, please contact us on (07) 3357 3357.</span>'+portalmessage;
            } 
          }
        ); 
        this.welcome_message = '<span class="welcome_title">Welcome</span><br><span class="welcome_text">Welcome to the web portal for Medbill clients!<br><br>Please login with your <span class="regapp">registered app credentials</span>.<br><br>If you need assistance logging in, please contact us on (07) 3357 3357.</span>'+portalmessage;
      }
    }

    ionViewWillLeave() {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
    }
  cancelLogin() {
    this.isLoginModalOpen = false;
  }
  cancelPassReset() {
    this.isResetModalOpen = false;
  }

  openLogin() {
    setTimeout(() => {
      this.usernameInput.setFocus();
    },150);
    this.modalLogin.present();
    this.isResetModalOpen = false;
    this.isLoginModalOpen = true;
  }
  openPassReset() {
    this.isLoginModalOpen = false;
    this.isResetModalOpen = true;
  }
  login() {
    if (!this.loginForm.valid) {
      this.loginError(null);
    }
    else
    {
      this.modalLogin.dismiss(null, 'confirm');
    }
  }

  logout() {
    this.loginForm.reset();
    this.apiService.weblogout();
    this.isLoggedIn = false;
    this.updateLogin(null); // Update the login status after logging out
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: Event): void {
    // Call the logout function when the user closes the window
    this.logout();
  }
  passreset()
  {
    if (!this.resetForm.valid) {
      this.resetError(null);
    }
    else
    {
      this.doPassReset();
    }
  }
  async doPassReset() {
   
      const loading = await this.loadingCtrl.create({
        message: 'Requesting Password Reset.  Please Wait...',
        mode: 'ios',
      });
      loading.present();
      this.apiService.post('forgot-password', this.resetForm.value).subscribe(
        async (res) => {
          loading.dismiss();
          if (res.error === false) {
            this.resetSuccess(res.message);
            this.isResetModalOpen = false;
          } else {
            this.resetError(res.message);
          }
        },
        (err) => { 
          loading.dismiss();
        }
      );
    
  }
  
  async onWillDismissLogin(event: Event) {
    const ev = event as CustomEvent<OverlayEventDetail<string>>;
    if (ev.detail.role === 'confirm') {
      this.dotheLogin();
    }
  }

  async dotheLogin()
  {
      const loading = await this.loadingCtrl.create({
        message: 'Logging in.  Please Wait...',
        mode: 'ios',
      });

      //login
      const params = {
        User: this.loginForm.value,
      };

      loading.present();
      this.apiService.login('login-user', params).subscribe(
        async (res) => {
          loading.dismiss();

          if (res.error === false) {
            if (this.rememberme)
            {             
            }
            await this.storageService.setObject('mbeUser', res.userInfo);
            await this.storageService.set('userInfo', this.loginForm.value); 
            //console.log(res);
            this.storageService.get('userInfo').then(res2 => {
              //console.log('UserInfo: ',res2);
              //console.log(this.loginForm.value);
            });
            this.storageService.get('mbeUser').then(res3 => {
              //console.log('MBE: ',res3);
            });
            
            this.events.publish('user:active', this.loginForm.value);
            this.events.setDoctorRole(res.userInfo.anaesthetics, res.userInfo.icu, res.userInfo.physician, res.userInfo.surgeon);
            this.updateuserlogin();
            
            this.updateLogin(res.userInfo);
            //this.navCtrl.navigateRoot('/lock');
          } else {
            this.loginError(res.error.uiMessage);
            //this.toastService.presentToastError(res.error.uiMessage);
          }
        },
        (err) => {
          loading.dismiss();
        }
      );    
  }

  updateuserlogin() {
    const params = {
      platform: Capacitor.getPlatform()
    };
    this.apiService.post('updatelastlogin',params).subscribe(
      (res) => {
        if (res.error === false) {
        }
      },
      (err) => {
      }
    );
  }

  rememberMe() 
  {
    if (this.rememberme)
    {
      this.rememberme = false;
    }
    else
    {
      this.rememberme = true;

    }
    //console.log(this.rememberme);
  }



  

}
